import React, { useEffect } from 'react'
import { StringParam, useQueryParam } from 'use-query-params'

import { useDashboardPermissions } from '@components'
import { useMediaQueryContext, useModalContext } from '@fourthwall/components'
import { AddProductToFavoritesModal, CampaignBanner } from '@fourthwall/module-product'

import { useGetCampaignQuery } from '../useGetCampaignQuery'
import { useAddProductToFavoritesMutation } from './queries/useAddProductToFavoritesMutation/useAddProductToFavoritesMutation'
import { useCatalogProductQuery } from './queries/useCatalogProductQuery'
import { useDeleteProductFromFavoritesMutation } from './queries/useDeleteProductFromFavoritesMutation/useDeleteProductFromFavoritesMutation'

export const useAddProductToFavoritesModal = () => {
  const [fromProductParam, setFromProductParam] = useQueryParam('fromProduct', StringParam)
  const { tablet } = useMediaQueryContext()
  const { open, close } = useModalContext()
  const { hasPermission } = useDashboardPermissions()

  const { addProductToFavoritesMutation } = useAddProductToFavoritesMutation()
  const { deleteProductFromFavoritesMutation } = useDeleteProductFromFavoritesMutation()
  const { catalogProductQuery } = useCatalogProductQuery([fromProductParam!], {
    enabled: Boolean(fromProductParam),
  })
  const { campaignQuery } = useGetCampaignQuery(undefined, {
    enabled: hasPermission('home.campaign'),
  })

  useEffect(() => {
    if (
      fromProductParam &&
      !tablet &&
      catalogProductQuery.data &&
      !campaignQuery.isInitialLoading
    ) {
      const product = catalogProductQuery.data

      open(AddProductToFavoritesModal, {
        product,
        isFavorite: product.favourite,
        disabled: catalogProductQuery.isFetching,
        onAdd: async () => {
          await addProductToFavoritesMutation.mutateAsync([product.slug], {
            onSettled: () => {
              setFromProductParam(undefined)
            },
          })
        },
        onRemove: async () => {
          await deleteProductFromFavoritesMutation.mutateAsync([product.slug], {
            onSuccess: () => {
              setFromProductParam(undefined)
            },
          })
        },
        onClose: () => {
          close()
          setFromProductParam(undefined)
        },
        banner: <CampaignBanner campaign={campaignQuery.data} />,
      })
    }
  }, [
    tablet,
    fromProductParam,
    open,
    setFromProductParam,
    catalogProductQuery,
    close,
    addProductToFavoritesMutation,
    deleteProductFromFavoritesMutation,
    campaignQuery.isInitialLoading,
    campaignQuery.data,
  ])
}
